import { SVGProps } from 'react'

export const AssignRole = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_9532_1356)">
      <path
        d="M10.0001 4.58329L6.13474 10.2056C5.90205 10.5441 5.7857 10.7133 5.79269 10.854C5.79878 10.9765 5.85854 11.0901 5.95605 11.1645C6.068 11.25 6.27337 11.25 6.6841 11.25H10.0001V15.4166L13.8654 9.79431C14.0981 9.45585 14.2145 9.28662 14.2075 9.14595C14.2014 9.02344 14.1416 8.90983 14.0441 8.83541C13.9322 8.74996 13.7268 8.74996 13.3161 8.74996H10.0001V4.58329Z"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333Z"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9532_1356">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
